import React, { useEffect, useState } from 'react';
import apiClient, { getViewAs, getMyReport, setMyReport } from '../services/apiClient';

// OWN-PARTY v1: for a full-access user who is also a Ref. Party. One click switches between "my own Ref. Party report"
// (looks exactly like a Ref. Party user's software) and "All Ref. Parties".
export default function MyReportSwitch({ user }) {
  const [info, setInfo] = useState(null);
  const uid = user && user.id;
  useEffect(() => {
    if (!uid || getViewAs()) return undefined;
    let alive = true;
    apiClient.get('/auth/my-report').then((r) => { if (alive) setInfo(r.data.data); }).catch(() => {});
    return () => { alive = false; };
  }, [uid]);
  if (!info || !info.ownRefPartyId || getViewAs()) return null;
  const own = getMyReport();
  return (
    <button
      type="button"
      onClick={() => setMyReport(!own)}
      title={own ? 'Go back to all Ref. Parties' : 'See only my own Ref. Party report'}
      style={{ position: 'fixed', zIndex: 3000, left: 14, bottom: 14, padding: '8px 14px', borderRadius: 10, cursor: 'pointer', fontWeight: 700,
        border: '1px solid var(--color-border, #ccc)', boxShadow: '0 6px 24px rgba(0,0,0,0.25)',
        background: own ? '#0E6F8A' : 'var(--color-surface, #fff)', color: own ? '#fff' : 'var(--color-text-primary, #111)' }}
    >
      {own ? `📊 My report: ${info.ownName || ''} — switch to All Ref. Parties` : `📊 My Ref. Party report${info.ownName ? ` (${info.ownName})` : ''}`}
    </button>
  );
}
